// Navbar.js

import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";

export const Navbar = () => {
  const { pathname } = useLocation();
  const overHero = pathname === "/";
  const [heroPassed, setHeroPassed] = useState(false);

  // Only the home page has a hero to sit over. Everywhere else the bar is
  // solid from the start, otherwise white text would land on a light page.
  useEffect(() => {
    if (!overHero) return undefined;

    const hero = document.querySelector(".hero");
    if (!hero) return undefined;

    setHeroPassed(false);

    // Flips once the hero's bottom edge clears the bar.
    const observer = new IntersectionObserver(
      ([entry]) => setHeroPassed(!entry.isIntersecting),
      { rootMargin: "-72px 0px 0px 0px", threshold: 0 }
    );
    observer.observe(hero);

    return () => observer.disconnect();
  }, [overHero]);

  const isSolid = !overHero || heroPassed;

  return (
    <header className={`navbar-container${isSolid ? " is-solid" : ""}`}>
      <nav className="navbar">
        <Link to="/" className="home-button" aria-label="AIM, home">
          <div className="aim-text brand-wordmark">
            <span>AIM</span>
          </div>
        </Link>

        <div className="nav-links">
          <Link to="/" className="nav-link poppins-regular">
            Home
          </Link>
          <Link to="/create-inquiry" className="nav-cta poppins-regular">
            Inquiry
          </Link>
        </div>

        <div className="contact-info">
          <span className="contact-info__address poppins-regular-light-nav">
            260 El Camino Real, San Carlos
          </span>
          <a className="contact-info__phone" href="tel:+16508625588">
            (650)862-5588
          </a>
        </div>
      </nav>
    </header>
  );
};
